import React, { useEffect } from "react";
import HeroSection from "./HeroSection";
import ProductDetails from "./ProductDetails";
import Benefits from "./Benefits";
import FAQSection from "./FAQSection";

import main from "../assets/balconynets/main.jpg";
import img1 from "../assets/balconynets/1.jpg";
import img2 from "../assets/balconynets/2.jpg";
import img3 from "../assets/balconynets/3.jpg";
import Images from "./Images";
import { Helmet } from "react-helmet-async";

export default function BalconySafetyNets() {

       useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Balcony Safety Nets in Bengaluru - ANS Safety Nets",
    url: "https://www.anssafetynets.com/balconysafenets",
    description:
      "Ensure safety with high-quality Balcony Safety Nets by ANS Safety Nets in Bengaluru. Trusted solutions for homes and apartments to protect your loved ones.",
    keywords: [
      "ANS Safety Nets",
      "Balcony Safety Nets",
      "Safety Nets in Bengaluru",
      "Apartment Safety nets",
      "Balcony safety Nets by ANS Safety Nets",
      "safety nets in bengaluru",
      "ans safety nets",
      "Ans Safety Nets bengaluru",
      "Safety Nets in Bengaluru",
      "Safety Solutions",
      "Bengaluru Safety Nets",
      "balcony safety nets in bengaluru",
      "balcony safety nets",
      "pigeon safety nets in bengaluru",
      "monkey safety nets in bengaluru",
      "Ducteria Nets in bengaluru",
      "Pets Safety Nets in bengaluru",
      "Industrial Safety Nets in bengaluru",
      "Children Safety Nets in bengaluru",
      "Bird Spikes in Bengaluru",
      "Cricket Practice Nets in bengaluru",
      "Sports Nets",
      "Pigeon Safety Nets",
      "Building covering Net",
      "sports nets in bengaluru",
      "building covering nets in bengaluru",
    ],
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.anssafetynets.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Balcony Safety Nets",
          item: "https://www.anssafetynets.com/balconysafenets",
        },
      ],
    },
    publisher: {
      "@type": "Organization",
      name: "ANS Safety Nets",
      logo: {
        "@type": "ImageObject",
        url: "https://www.anssafetynets.com/logo.png",
        width: 250,
        height: 100,
      },
      contactPoint: [
        {
          "@type": "ContactPoint",
          telephone: "+91-7416116587",
          contactType: "Customer Service",
          areaServed: "IN",
          availableLanguage: ["English", "Kannada"],
        },
      ],
      sameAs: [
        "https://www.facebook.com/profile.php?id=61572534324956",
        "https://www.instagram.com/anssafetynets_bengaluru/",
      ],
    },
    mainEntity: {
      "@type": "Organization",
      name: "ANS Safety Nets",
      address: {
        "@type": "PostalAddress",
        streetAddress:
          "74/9, 5th Cross Rd, Muthyala Nagar, Bahubali Nagar, Jalahalli, Bengaluru, Karnataka 560013",
        addressLocality: "Bengaluru",
        addressRegion: "KA",
        postalCode: "560013",
        addressCountry: "IN",
      },
      service: [
        {
          "@type": "Service",
          name: "Balcony Safety Nets",
          areaServed: "Bengaluru",
        },
      ],
    },
  };

  return (
    <div>
      <Helmet>
        <title>Balcony Safety Nets in Bengaluru - ANS Safety Nets</title>
        <meta
          name="description"
          content="Ensure safety with high-quality Balcony Safety Nets by ANS Safety Nets in Bengaluru. Trusted solutions for homes and apartments to protect your loved ones.
"
        />
        <meta
          name="keywords"
          content="ANS Safety Nets, Balcony Safety Nets, Safety Nets in Bengaluru, Apartment Safety nets, Balcony safety Nets by ANS Safety Nets,safety nets in bengaluru , ans safety nets ,Ans Safety Nets bengaluru, Safety Nets in Bengaluru, ANS Safety Nets, safety nets in bengaluru, Safety Solutions, Bengaluru Safety Nets , balcony safety nets in bengaluru , balcony safety nets,pegion safety nets in bengaluru, monkey safety nets in bengaluru,Ducteria Nets in bengaluru, Pets Safety Nets in bengaluru, Industrial Safety Nets in bengaluru, Children Safety Nets in bengaluru, Bird Spikes in , Cricket Practice Nets in bengaluru,Sports Nets,Pigeon Safety Nets,Building covering Net,pigeon Safety Nets, Sports Nets in bengaluru,Pigeon Safety Nets in bengaluru,Building covering Net in bengaluru,pigeon Safety Nets in bengaluru"
        />
        <meta name="author" content="ANS Safety Nets, Bengaluru" />
        <link
          rel="canonical"
          href="https://www.anssafetynets.com/balconysafenets"
        />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      </Helmet>
      <HeroSection
        title="Balcony Safety Nets"
        description="Protect your loved ones with strong, durable balcony safety nets."
        bgColor="bg-[#2c3639]"
      />

      <ProductDetails
        title="Why Choose Our Balcony Safety Nets?"
        content="At ANS Safety Nets, we prioritize safety above all else, especially when it comes to your home. Balcony safety nets are essential to protect children, pets, and elderly family members from the dangers of open balconies. With more homes featuring high-rise apartments and terraces, the need for reliable safety nets is critical. Our nets are made from durable, high-quality materials, providing long-lasting protection.

We offer a range of sizes, colors, and designs to fit your balcony while enhancing its aesthetic appeal. Our discreet yet sturdy nets offer maximum safety without compromising on style. Whether you're in a high-rise or a ground-level home, our tailored solutions meet your specific needs.

Our professional team ensures secure installation, adhering to all safety standards. Made from weather-resistant materials, our safety nets are designed to endure harsh conditions and require minimal maintenance, making them a hassle-free choice."
        image={main}
      />
      <Images images={[img1, img2, img3]} />

      <Benefits
        benefits={[
          {
            title: "Child Safety",
            description: "Prevent accidental falls for children.",
          },
          {
            title: "Pet Protection",
            description: "Keep your pets safe on high floors.",
          },
          {
            title: "Weatherproof",
            description: "Durable and resistant to all weather conditions.",
          },
        ]}
      />

      <FAQSection
        faqs={[
          {
            question: "Are these nets easy to install?",
            answer:
              "Yes, our nets are designed for quick and hassle-free installation.",
          },
          {
            question: "Will the nets obstruct the view?",
            answer:
              "Not at all! Our nets are transparent and blend with your surroundings.",
          },
        ]}
      />
    </div>
  );
}
